<template>
    <section id="wrapper">
        <div class="container">
            <div class="base-container">
    <!-- Cancellation Policy -->
    <div class="rules">
        1. <strong>Order Cancellation:</strong>  
        Once an order is placed on 
        <a href="https://penpencilbd.com" target="_blank">penpencilbd.com</a>, it cannot be 
        cancelled or exchanged after confirmation.
    </div>

    <!-- Damaged or Wrong Product -->
    <div class="rules">
        2. <strong>Damaged / Wrong Product Reporting:</strong>
        <ol>
            <li>
                Please check your parcel at the time of delivery. If you receive a 
                damaged or incorrect item, notify our delivery partner immediately.
            </li>
            <li>
                If the issue is not resolved at the time of delivery, please report it 
                within <strong>48 hours</strong> of receiving your order by sending 
                clear photographs, your order number, and a brief description of the 
                issue to 
                <a href="mailto:info.penpencilbd@gmail.com">info.penpencilbd@gmail.com</a>.
            </li>
            <li>
                After verification, our support team will arrange for repair, 
                replacement, or a refund depending on the situation.
            </li>
        </ol>
    </div>

    <!-- Warranty -->
    <div class="rules">
        3. <strong>Warranty:</strong>
        <ol>
            <li>
                Stationery products are generally not covered under warranty. However, 
                in case of <strong>manufacturing defects</strong> (e.g., printing 
                errors, faulty binding, missing pages, pen not writing), we will 
                replace the item free of charge if reported within 
                <strong>7 days</strong> of delivery.
            </li>
            <li>
                Damages caused by misuse, mishandling, or normal wear & tear 
                (e.g., torn pages, broken nibs due to pressure, water damage) 
                will not be eligible for replacement or refund.
            </li>
        </ol>
    </div>

    <!-- Resolution -->
    <div class="rules">
        4. <strong>Resolution for Defective Products:</strong>  
        Depending on availability and our assessment, we may:
        <ol>
            <li>Replace the defective product with the same item.</li>
            <li>Offer an alternative product of similar value.</li>
            <li>Provide a store credit or refund if replacement is not possible.</li>
        </ol>
    </div>

    <!-- Modification -->
    <div class="rules">
        5. <strong>Product Modification:</strong>  
        Customers are requested not to alter or modify stationery products. 
        Modified products will not be eligible for return, exchange, or refund.
    </div>

    <!-- Exchange Policy -->
    <div class="rules">
        6. <strong>Exchange:</strong>
        <ol>
            <li>
                Exchanges are only allowed if you receive a defective or wrong item 
                and report it within <strong>7 days</strong> of delivery.
            </li>
            <li>
                To initiate an exchange, please contact our customer care team with 
                your order details at 
                <a href="mailto:info.penpencilbd@gmail.com">info.penpencilbd@gmail.com</a>.
            </li>
        </ol>
    </div>
</div>

        </div>
    </section>
</template>

<script></script>

<style lang="scss">
// .base-container {
//     padding: 100px 10%;
// }

.hr-line {
    border: 1px solid #e6e6e6;
    margin-bottom: 30px;
}

.return-and-refund-headline {
    font-weight: 500;
    font-size: 30px;
}

.rules {
    font-weight: 400;
    // font-size: 20px;
    line-height: 130%;

    margin-bottom: 20px;
}

@media screen and (min-width: 577px) and (max-width: 1024px) {
    .base-container {
        padding: 90px !important;
    }

    .hr-line {
        border: 1px solid #e6e6e6;
        margin-bottom: 30px;
    }

    .return-and-refund-headline {
        font-weight: 500;
        font-size: 25px;
    }

    .rules {
        font-weight: 400;
        font-size: 18px;
        line-height: 130%;

        margin-bottom: 20px;
    }
}

@media screen and (min-width: 0px) and (max-width: 576px) {
    .base-container {
        padding: 60px;
    }

    .hr-line {
        border: 1px solid #e6e6e6;
        margin-bottom: 30px;
    }

    .return-and-refund-headline {
        font-weight: 500;
        font-size: 20px;
    }

    .rules {
        font-weight: 400;
        font-size: 15px;
        line-height: 130%;

        margin-bottom: 20px;
    }
}
</style>
